"use strict";exports.__esModule=true;exports.default=void 0;var appearing=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}],updating=[{slot:"plot",startEnd:{start:0,end:.5}}],disappearing=[{slot:"intial"}];var _default={"*.legend.legend":function legendLegend(){return{"legendGroup.appearing":appearing,"legendGroup.updating":updating,"legendGroup.disappearing":disappearing,"scrollbar.appearing":appearing,"scrollbar.updating":updating,"scrollbar.disappearing":disappearing}}};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/_internal/components/legend/discrete/index.animation.js
// module id = KNXJ
// module chunks = 5